import { EVENTS } from '../constants/webSocketConsts/events';
import { setCustomFieldsAction } from '../store/clients/actions';
import { CustomFieldEntity } from '../store/clients/types';

export interface CustomFieldWSEntity extends CustomFieldEntity {
  fields: {
    addedCustomFields?: string[];
    deletedCustomFields?: string[];
  };
}

const CustomFieldsHandler = (
  event: string,
  items: Array<CustomFieldWSEntity>,
) => {
  if (items && items.length === 0) {
    return null;
  }
  switch (event) {
    case EVENTS.INSERT:
      return setCustomFieldsAction(items[0], '');
    case EVENTS.MODIFY: {
      // since we're using update api to delete custom fields
      // we need to distinguish the websocket message whether it
      // is an update deletion action.
      const isDeleteWsMessage = items[0].fields.deletedCustomFields !== null;
      const stagedUpdatedFields = {
        ...items[0],
        // currently when websocket modify/delete events are
        // received they contains the diff values (updatedFields, removedFields)
        // we don't need to save them in custom fields entity.
        fields: null,
      };
      return setCustomFieldsAction(stagedUpdatedFields, '', isDeleteWsMessage);
    }
    default:
      break;
  }
  return null;
};

export default CustomFieldsHandler;
